// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__1WW+x","title":"SignUp_title__gEtud","input":"SignUp_input__TnPlg","submit_button":"SignUp_submit_button__SHBUp"};